import { APPTYPE_UPDATE } from '../constants/appType';

const defaultAppType = 1;
export default function appType(state = defaultAppType, action) {
    if (action.type === APPTYPE_UPDATE) {
        return state = action.payload;
    }
    return state;
}